/* eslint-disable */
window.PXUTheme.jsHeader = {
  init: function($section) {
    window.PXUTheme.jsHeader = $.extend(this, window.PXUTheme.getSectionData($section));

    this.$el = $('#header');
    this.$menuToggle = this.$el.find('.header__menu-toggle');
    let announcementHeight = $('.announcement-sticky-wrapper').height();

    if (this.enable_overlay === true && isScreenSizeLarge()) {
      this.updateOverlayStyle(this.sectionUnderlayIsImage());
    }

    if (this.enable_sticky === true && isScreenSizeLarge()) {
      this.enableSticky(announcementHeight);

      $(window).on('resize', () => {
        this.enableSticky(announcementHeight);
      });
    }

    if (this.header_layout == 'centered' || this.header_layout == 'search_focus') {
      this.$menuToggle.on('click', () => {
        this.showStickyMenu();
      });
    } else if (this.header_layout == 'vertical') {
      $section.find('.header-sticky-wrapper').stick_in_parent();
      this.addOffScreenDropdownCheck();
    }

    if ($('.mega-menu').length > 0 && window.PXUTheme.jsMegaMenu) {
      window.PXUTheme.jsMegaMenu.init($section);
    }

    if (!isScreenSizeLarge()) {
      this.unload();
      window.PXUTheme.mobileMenu.init();
      return;
    }

    $('.search-overlay__close').on('click', function() {
      window.PXUTheme.jsHeader.hideSearch();
    });

    $(document).on('click', '[data-show-search-trigger]', function() {
      window.PXUTheme.jsHeader.showSearch();
    });

    $(document).on('keydown', '[data-show-search-trigger]', function(e) {
      if (e.which === 13) {
        window.PXUTheme.jsHeader.showSearch();
      }
    });

    this.bindAccessibleNav();

    if (window.PXUTheme.theme_settings.search_layout == 'overlay') {
      document.body.addEventListener('click', e => {
        if (e.target === document.querySelector('[data-site-overlay]')) {
          window.PXUTheme.jsHeader.hideSearch();
        }
      });
    }
  },

bindAccessibleNav: function() {
  const self = this;

  $(document).off('click.pxuHeaderNav', '[data-nav-trigger]');
  $(document).off('keydown.pxuHeaderNav', '[data-nav-trigger]');
  $(document).off('keydown.pxuHeaderPanel', '.header__nav-panel, .mega-menu');
  $(document).off('click.pxuHeaderOutside');
  $(document).off('mouseenter.pxuHeaderHover', '.navbar-item.has-dropdown, .navbar-item.has-mega-menu');
  $(document).off('mouseleave.pxuHeaderHover', '.navbar-item.has-dropdown, .navbar-item.has-mega-menu');

  $(document).on('click.pxuHeaderNav', '[data-nav-trigger]', function(e) {
    e.preventDefault();
    self.toggleAccessibleMenu($(this));
  });

  $(document).on('keydown.pxuHeaderNav', '[data-nav-trigger]', function(e) {
    const $trigger = $(this);

    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      self.toggleAccessibleMenu($trigger);
    }

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      self.openAccessibleMenu($trigger, true);
    }

    if (e.key === 'Escape') {
      e.preventDefault();
      self.closeAllAccessibleMenus($trigger);
    }
  });

  $(document).on('keydown.pxuHeaderPanel', '.header__nav-panel, .mega-menu', function(e) {
    if (e.key === 'Escape') {
      e.preventDefault();

      const panelId = $(this).attr('id');
      const $trigger = $('[aria-controls="' + panelId + '"]');

      self.closeAllAccessibleMenus($trigger);
    }
  });

  $(document).on('click.pxuHeaderOutside', function(e) {
    if ($(e.target).closest('[data-nav-trigger], .header__nav-panel, .mega-menu, .navbar-dropdown').length === 0) {
      self.closeAllAccessibleMenus();
    }
  });

  // Desktop hover open / close
  $(document).on('mouseenter.pxuHeaderHover', '.navbar-item.has-dropdown, .navbar-item.has-mega-menu', function() {
    if (!isScreenSizeLarge()) return;

    const $trigger = $(this).find('[data-nav-trigger]').first();
    if ($trigger.length) {
      self.openAccessibleMenu($trigger, false);
    }
  });

  $(document).on('mouseleave.pxuHeaderHover', '.navbar-item.has-dropdown, .navbar-item.has-mega-menu', function() {
    if (!isScreenSizeLarge()) return;
    self.closeAllAccessibleMenus();
  });
},

toggleAccessibleMenu: function($trigger) {
  const panelId = $trigger.attr('aria-controls');
  const $panel = $('#' + panelId);
  const hasPanelContent = $panel.length && $.trim($panel.html()).length > 0;
  const navUrl = $trigger.attr('data-nav-url');
  const isMegaMenuTrigger = $trigger.closest('.has-mega-menu').length > 0;
  const expanded = $trigger.attr('aria-expanded') === 'true';

  if (!hasPanelContent && !isMegaMenuTrigger) {
    if (navUrl && navUrl !== '#' && navUrl !== '' && navUrl !== 'http://' && navUrl !== 'https://') {
      window.location.href = navUrl;
    }
    return;
  }

  if (expanded) {
    this.closeAllAccessibleMenus($trigger);
  } else {
    this.openAccessibleMenu($trigger, false);
  }
},

openAccessibleMenu: function($trigger, moveFocusIntoPanel) {
  const panelId = $trigger.attr('aria-controls');
  const $panel = $('#' + panelId);
  const $parentWrap = $trigger.closest('.has-dropdown, .has-mega-menu, .navbar-item');

  this.closeAllAccessibleMenus();

  $parentWrap.addClass('is-opened');
  $trigger.attr('aria-expanded', 'true');
  $panel.prop('hidden', false);

  if ($panel.hasClass('mega-menu') || $panel.closest('.mega-menu__section').length) {
    $panel.closest('.mega-menu__section').addClass('is-active');
  }

  if (moveFocusIntoPanel) {
    const $firstFocusable = $panel
      .find('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])')
      .filter(':visible')
      .first();

    if ($firstFocusable.length) {
      $firstFocusable.focus();
    }
  }
},

closeAllAccessibleMenus: function($returnFocusTo) {
  $('[data-nav-trigger][aria-expanded="true"]').attr('aria-expanded', 'false');
  $('.has-dropdown, .has-mega-menu').removeClass('is-opened');
  $('.mega-menu__section').removeClass('is-active');

  $('.header__nav-panel, .mega-menu').each(function() {
    $(this).prop('hidden', true);
  });

  if ($returnFocusTo && $returnFocusTo.length) {
    $returnFocusTo.focus();
  }
},

  collapseSubmenu: function(el) {
    $(el).find('.has-submenu input').prop('checked', false);
  },

  showStickyMenu: function() {
    this.$menuToggle.toggleClass('is-active');
    this.$el.find('.sticky-menu-wrapper').toggleClass('is-visible');
  },

  hideStickyMenu: function() {
    this.$menuToggle.removeClass('is-active');
    this.$el.find('.sticky-menu-wrapper').removeClass('is-visible');
  },

  disableSticky: function() {
    let $stickyEl = $('#header');

    $stickyEl.unstick();
    $stickyEl.removeClass('sticky--enabled');

    setTimeout(function() {
      $stickyEl.css('height', 'auto');
    }, 250);
  },

  enableSticky: function(offset) {
    let $stickyEl = this.$el;

    $stickyEl.addClass('sticky--enabled');

    $stickyEl.sticky({
      wrapperClassName: 'header-sticky-wrapper',
      zIndex: 70,
      topSpacing: offset || 0
    })
    .on('sticky-start', () => {
      let headerHeight;
      let announcementHeight;

      if (window.PXUTheme.theme_settings.header_layout == 'centered') {
        $('.top-bar [data-ajax-cart-trigger] [data-ajax-cart-mini_cart]').css('display', 'none');
      }

      if (window.PXUTheme.jsHeader.enable_sticky == true && window.PXUTheme.theme_settings.header_layout != 'vertical') {
        headerHeight = window.PXUTheme.jsHeader.getHeaderHeight();
      }

      if (typeof window.PXUTheme.jsAnnouncementBar !== 'undefined' && window.PXUTheme.jsAnnouncementBar.enable_sticky == true && window.PXUTheme.theme_settings.header_layout != 'vertical') {
        announcementHeight = window.PXUTheme.jsAnnouncementBar.getAnnouncementHeight();
      } else {
        announcementHeight = 0;
      }

      let totalHeight = headerHeight + announcementHeight;
      $stickyEl.parent().parent().find('.search-overlay').addClass('sticky-search').css('top', totalHeight + 'px');

      if (this.enable_overlay === true && this.sectionUnderlayIsImage() === true) {
        $stickyEl.parent().addClass('has-overlaid-header');
        this.disableOverlayStyle();
      } else if (this.enable_overlay === true) {
        this.disableOverlayStyle();
      }
    })
    .on('sticky-end', () => {
      $stickyEl.parent().parent().find('.search-overlay').removeClass('sticky-search').css('top', '100%');

      setTimeout(() => {
        $stickyEl.sticky('update');
      }, 250);

      if (window.PXUTheme.theme_settings.header_layout == 'centered') {
        $('.top-bar [data-ajax-cart-trigger] [data-ajax-cart-mini_cart]').css('display', 'block');
      }

      this.$el.find('.sticky-menu-wrapper').removeClass('is-visible');
      this.$menuToggle.removeClass('is-active');

      if (this.enable_overlay === true && this.sectionUnderlayIsImage() === true) {
        this.updateOverlayStyle(this.sectionUnderlayIsImage());
      }
    });
  },

  disableOverlayStyle: function() {
    $('[data-enable_overlay]').attr('data-enable_overlay', false);
  },

  enableOverlayStyle: function() {
    $('[data-enable_overlay]').attr('data-enable_overlay', true);
  },

  updateOverlayStyle: function(overlayBoolean) {
    $('[data-enable_overlay]').attr('data-enable_overlay', overlayBoolean);
  },

  sectionUnderlayIsImage: function() {
    let $firstSection = $('[data-check-for-order=true]').find('[id^=shopify-section]').first();

    if ($firstSection.hasClass('overlaid-header-option') && $.trim($firstSection.html()).length > 0) {
      return true;
    } else {
      return false;
    }
  },

  showSearch: function() {
    $('[data-show-search-trigger]').addClass('is-active');

    if (window.PXUTheme.theme_settings.search_layout == 'overlay') {
      $('[data-search-type="overlay"]').addClass('is-opened');
      $('.search-form .search__fields input[type="text"]')[0].focus();
      window.PXUTheme.predictiveSearch.lockBodyScroll();
    } else {
      $.fancybox.open($('.js-search-popup'), {
        baseClass: 'search__lightbox',
        hash: false,
        infobar: false,
        toolbar: false,
        loop: true,
        smallBtn: true,
        mobile: {
          preventCaptionOverlap: false,
          toolbar: false,
        },
        touch: false,
        beforeClose: function() {
          $('[data-show-search-trigger]').removeClass('is-active');
        },
        afterShow: function() {
          const searchInputEl = $('.search-form .search__fields input[type="text"]')[0];
          const searchTermLength = searchInputEl.value.length;
          searchInputEl.setSelectionRange(searchTermLength, searchTermLength);
        },
      });
    }
  },

  hideSearch: function() {
    $('[data-show-search-trigger]').removeClass('is-active');
    if (window.PXUTheme.theme_settings.search_layout == 'overlay' || window.PXUTheme.theme_settings.header_layout == 'search_focus' || window.PXUTheme.theme_settings.header_layout == 'vertical') {
      $('[data-autocomplete-true] .search__results-wrapper').hide();
      $('[data-search-type="overlay"]').removeClass('is-opened');
      window.PXUTheme.predictiveSearch.unlockBodyScroll();
    } else {
      $.fancybox.close($('[data-search-type="' + window.PXUTheme.theme_settings.search_layout + '"]'));
    }
  },

  addOffScreenDropdownCheck: function() {
    $('.navbar-item.has-dropdown--vertical').hover(function() {
      const dropdown = $(this),
        menu = dropdown.find('.navbar-dropdown');

      menu.removeClass('navbar-dropdown--fix-offscreen');

      if (menu.is(':off-screen')) {
        menu.addClass('navbar-dropdown--fix-offscreen');
      }
    });
  },

  getHeaderHeight: function() {
    const headerHeight = $('.header-section').outerHeight() || 0;
    return headerHeight;
  },

unload: function() {
  $('.has-overlaid-header').removeClass('has-overlaid-header');
  $('[data-show-search-trigger]').off();
  $('.navbar-item').off();
  $('#header').off();
  $(document).off('.pxuHeaderNav');
  $(document).off('.pxuHeaderPanel');
  $(document).off('click.pxuHeaderOutside');
  $(document).off('.pxuHeaderHover');
  this.$menuToggle.off();
  this.disableSticky();
  this.disableOverlayStyle();
}
};